import React from 'react';
import { Alert } from '@instructure/ui-alerts';
import t from '@instructure/quiz-i18n/es/format-message';
export var SessionBreachAlert = function SessionBreachAlert() {
  return /*#__PURE__*/React.createElement(Alert, {
    variant: "warning",
    margin: "small"
  }, t('Potential breach: This Quiz appears to have been accessed from multiple devices or browsers.'), /*#__PURE__*/React.createElement("br", null), t('Review the activity log and take appropriate action.'));
};